import { AppTheme } from "./types";

export const appThemes: AppTheme[] = [
    {
        id: "default",
        name: "Por defecto",
        colors: ["#02a902", "#212529", "green", "rgb(24, 24, 24)"],
        dark: true
    },
    {
        id: "light",
        name: "Claro",
        colors: ["#02a902", "#919090ff", "green", "#f4f6fb"],
        dark: false
    },
    {
        id: "forest",
        name: "Bosque",
        colors: ["#52b788", "#143627", "#74c69d", "#081c15"],
        dark: true
    },
    {
        id: "lava",
        name: "Lava",
        colors: ["#ff4500", "#1a0f0f", "#ffa500", "#0c0606"],
        dark: true
    },
    {
        id: "sea",
        name: "Marino",
        colors: ["#00b4d8", "#0b1c3a", "#00f5d4", "#051622"],
        dark: true
    },
    {
        id: "glacier",
        name: "Glaciar",
        colors: ["#0077b6", "#ffffff", "#0096c7", "#f0f8ff"],
        dark: false
    },
    {
        id: "magic",
        name: "Magia",
        colors: ["#9b5de5", "#1d0e34", "#f15bb5", "#0f051d"],
        dark: true
    },
    {
        id: "sakura",
        name: "Sakura",
        colors: ["#ff85a1", "#ffffff", "#ff4d6d", "#fff0f3"],
        dark: false
    },
    {
        id: "cyberpunk",
        name: "Cyberpunk",
        colors: ["#00f5d4", "#0f0d1e", "#ff007f", "#080710"],
        dark: true
    },
    {
        id: "synthwave",
        name: "Synthwave",
        colors: ["#ff007f", "#1c053a", "#00f5d4", "#110221"],
        dark: true
    },
    {
        id: "retro",
        name: "Retro",
        colors: ["#d4a373", "#27201b", "#faedcd", "#1a1512"],
        dark: true
    },
    {
        id: "monochrome",
        name: "Monocromo",
        colors: ["#ffffff", "#121212", "#aaaaaa", "#000000"],
        dark: true
    },
    {
        id: "clean",
        name: "Limpio",
        colors: ["#000000", "#ffffff", "#333333", "#ffffff"],
        dark: false
    }
]